import { ContactSupportOutlined } from '@material-ui/icons';
import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

export default async function sendEmails(email, setLoading) {
	var attachments = email.attachments;

	console.log('attachments', attachments);

	var emailRef = await firebase.database().ref('/marketingEmails').push();

	for (let i = 0; i < attachments.length; i++) {
		var storage = await firebase
			.storage()
			.ref(
				PROJECT_CODE.projectCode +
					'/sendEmailMarketingAttachments/' +
					emailRef.key +
					'/' +
					attachments[i].name
			);

		await storage.put(attachments[i]);
	}

	var storageRef = await firebase
		.storage()
		.ref(
			PROJECT_CODE.projectCode +
				'/sendEmailMarketingAttachments/' +
				emailRef.key
		);

	var attachmentsArr = new Array();
	await storageRef.listAll().then(function (result) {
		result.items.forEach(function (imageRef) {
			var attachmentObj;
			imageRef.getDownloadURL().then(function (url) {
				var imageName = imageRef.name;
				attachmentObj = {
					fileName: imageName,
					href: url,
				};
				attachmentsArr.push(attachmentObj);
			});
		});
	});

	//@TODO: Loop throught the email address and set sentEmail boolean to true

	var emailsArr = email.emails;
	var ccEmailsArr = email.ccEmails;

	emailsArr?.map((email) => {
		var leadKey;
		firebase
			.database()
			.ref('/kavtek_leads/')
			.orderByChild('clientEmail')
			.equalTo(email)
			.limitToFirst(1)
			.once('value', (snapshot) => {
				leadKey = snapshot.val();

				var leadKeyKeys = Object.keys(leadKey);

				var k;

				leadKeyKeys.forEach((key) => {
					k = key;
				});

				leadKey = k;
			});

		console.log('leadKey', leadKey);

		var leadRef = firebase.database().ref('/kavtek_leads/' + leadKey);

		leadRef.update({
			sentEmail: true,
		});
	});

	ccEmailsArr?.map((email) => {
		var leadKey;

		firebase
			.database()
			.ref('/kavtek_leads/')
			.orderByChild('clientEmail')
			.equalTo(email)
			.limitToFirst(1)
			.once('value', (snapshot) => {
				leadKey = snapshot.val();

				var leadKeyKeys = Object.keys(leadKey);

				var k;

				leadKeyKeys.forEach((key) => {
					k = key;
				});

				leadKey = k;
			});

		var leadRef = firebase.database().ref('/kavtek_leads/' + leadKey);

		leadRef.update({
			sentEmail: true,
		});
	});

	setTimeout(() => {
		emailRef.set({
			emails: email.emails,
			ccEmails: email.ccEmails,
			subject: email.subject,
			body: email.body,
			attachments: attachmentsArr,
		});
	}, 1000);

	await setLoading(false);
}
